<div class="flex h-full w-full flex-col">
  <div
    class="relative flex h-[72px] items-center justify-between overflow-auto px-6 shadow"
  >
    <m-logo></m-logo>
  </div>
  <div class="h-2 flex-1 overflow-auto">
    <router-outlet></router-outlet>
  </div>
</div>
